import { __ } from "@wordpress/i18n";
import ColorSettings from "./ColorSettings";
import {
  PanelBody,
  __experimentalBorderBoxControl as BorderBoxControl,
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
} from "@wordpress/components";

export default function DefaultStateStyleSettings({
  attributes,
  setAttributes,
}) {
  const { defaultStyles } = attributes;
  const handleUpdateColorValue = (key, value) => {
    setAttributes({
      defaultStyles: { ...defaultStyles, [key]: value },
    });
  };
  return (
    <>
      <PanelBody
        title={__("Default State Styles", "brandy")}
        initialOpen={false}
      >
        <div className="brandy-add-to-compare-list-color-settings">
          <ColorSettings
            title={__("Colors", "brandy-blocks")}
            backgroundColor={defaultStyles.backgroundColor}
            textColor={defaultStyles.textColor}
            handleUpdateColorValue={handleUpdateColorValue}
          />
        </div>
        <div className="brandy-add-to-compare-list-border-settings">
          <ToolsPanel label={__("Borders", "brandy-blocks")}>
            <ToolsPanelItem
              hasValue={() => true}
              label={__("Border", "brandy")}
              onDeselect={() => {
                setAttributes({
                  defaultStyles: { ...defaultStyles, borders: {} },
                });
              }}
              isShownByDefault
            >
              <BorderBoxControl
                colors={
                  wp.data.select("core/editor").getEditorSettings().colors
                }
                label={__("Borders", "brandy-blocks")}
                value={defaultStyles.borders}
                onChange={(value) => {
                  handleUpdateColorValue("borders", value);
                }}
              />
            </ToolsPanelItem>
          </ToolsPanel>
        </div>
      </PanelBody>
    </>
  );
}
